































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AnalyticEmpty extends Vue {
    public state = true;

    get analyticEmptyState() {
        if (this.state) {
            return {
                backgroundColor: this.$vuetify.theme.veryLightBlue,
                buttonColor: 'primary',
            };
        }
        return {
            backgroundColor: this.$vuetify.theme.lightPink,
            buttonColor: 'error',
        };
    }

    get isVerified() {
        return this.$store.getters.getAuth.verified;
    }
}
